module.exports = __webpack_public_path__ + "media/images/ojigi_nurse_man-6bf5bb869a9ed3fd750b69dfc4e26816.png";